import * as React from "react";
import { ButtonProps } from "@material-ui/core/Button";
import { useStyles } from "@search/SearchResult/EndOfList";
import MdArrowDropDown from "react-icons/lib/md/arrow-drop-down";
import RegularButton from "../buttons/RegularButton";

export function IconButton(props: ButtonProps) {
  const { ...rest } = props;
  const classes = useStyles({});
  return (
    <RegularButton className={classes.root} {...rest} data-test="DropdownButtonArrow">
      <MdArrowDropDown size={20} />
    </RegularButton>
  );
}
